import { LoginError } from "./LoginError.js";
import { UserAuthCard } from "./UserAuthCard.js";
import "react";
import { Button, Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/AuthWrapper2/components/Login/views/PickUser.tsx
function PickUser({ error, loading, onCancel, onPickUser, users }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-xl relative flex flex-col items-center",
		children: [
			users.length > 1 && /* @__PURE__ */ jsx("span", {
				className: "text-xl",
				children: "Pick User Profile"
			}),
			loading && /* @__PURE__ */ jsx(Loading, {
				overlay: true,
				size: "xxl"
			}),
			/* @__PURE__ */ jsx(LoginError, { message: error }),
			/* @__PURE__ */ jsx("div", {
				className: users.length > 1 ? "gap-sm grid grid-cols-1 sm:grid-cols-2" : "flex justify-center",
				children: users?.map((user) => /* @__PURE__ */ jsx(UserAuthCard, {
					onClick: () => onPickUser(user.user.id),
					user
				}, user.user.id))
			}),
			!loading && /* @__PURE__ */ jsx(Button, {
				className: "max-w-(--breakpoint-lg)",
				onClick: onCancel,
				size: "lg",
				subtle: true,
				fullWidth: true,
				children: "Cancel Login"
			})
		]
	});
}
export { PickUser };

//# sourceMappingURL=PickUser.js.map